export enum IReportApiEnum {
  ImpactSummaryReport = 'ImpactSummaryReport',
  AchievementSummaryReport = 'AchievementSummaryReport',
  StudentGradebookReport = 'StudentGradebookReport',
  StudentAchievementReport = 'StudentAchievementReport',
}
